import React, { useState, useEffect } from 'react';
import { batch, useDispatch } from 'react-redux';

import { Box } from '@missionlabs/smartagent-app-components';

import { EmailMessages, TaskAudit } from 'components';
import { ContactDetails } from 'widgets/ContactDetails';
import {
    fetchAttachmentUrls,
    fetchAutomatedRulesAudit,
    fetchQueuedTasksAudit,
} from 'store/contactSearch/contactSearch.actions';
import { attachmentsRequireTransformation } from '../../utils';
import { IInteraction } from '../../types';

import './task-view.scss';

export interface Props {
    interaction: IInteraction;
}

const TaskView: React.FC<Props> = ({ interaction }) => {
    const dispatch = useDispatch();

    const {
        ID: interactionID,
        emailMessages,
        queuedTasksAudit,
        automatedRulesAudit,
        messageId,
        hasAutoReply = false,
        attributes: { 'sa-threadID': threadId },
        attributesUpdated = false,
        actionAuditId,
    } = interaction;

    useEffect(() => {
        batch(() => {
            // Temporary batch until migration to React 18
            if (!queuedTasksAudit) dispatch(fetchQueuedTasksAudit(interactionID));
            if (!automatedRulesAudit) dispatch(fetchAutomatedRulesAudit(interactionID, actionAuditId));
        });
    }, []);

    emailMessages?.forEach(({ attachments, messageId }) => {
        if (attachmentsRequireTransformation(attachments)) {
            dispatch(fetchAttachmentUrls(attachments, messageId, threadId));
        }
    });

    const [viewPreviousEmailMessages, setViewPreviousEmailMessages] = useState<boolean>(false);

    return (
        <div className="task-view-container">
            <div className="task-view-container-left">
                <ContactDetails contact={attributesUpdated ? interaction : undefined} widgetTitle="Additional info" />
                <TaskAudit
                    automatedRulesAudit={automatedRulesAudit}
                    queuedTasksAudit={queuedTasksAudit}
                    hasAutoReply={hasAutoReply}
                />
            </div>
            <div className="task-view-container-right">
                <Box
                    className="task-view-email-content"
                    alt
                    collapse
                    header={<h1>Email Content</h1>}
                    boxLabel="Email Content"
                >
                    <EmailMessages
                        emailMessages={emailMessages}
                        highlightedMessageId={messageId}
                        viewPreviousEmailMessages={viewPreviousEmailMessages}
                        setViewPreviousEmailMessages={() => setViewPreviousEmailMessages(true)}
                    />
                </Box>
            </div>
        </div>
    );
};

export default TaskView;
